<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="宠物姓名" prop="name" >
        <a-input v-model="form.name" placeholder="请输入宠物姓名" />
      </a-form-model-item>
      <a-form-model-item label="宠物头像" prop="avatar" >
        <a-input v-model="form.avatar" placeholder="请输入宠物头像" />
      </a-form-model-item>
      <a-form-model-item label="品类ID" prop="categoryId" >
        <a-input v-model="form.categoryId" placeholder="请输入品类ID" />
      </a-form-model-item>
      <a-form-model-item label="品种ID" prop="breedId" >
        <a-input v-model="form.breedId" placeholder="请输入品种ID" />
      </a-form-model-item>
      <a-form-model-item label="性别：1公 2母" prop="gender" >
        <a-input v-model="form.gender" placeholder="请输入性别：1公 2母" />
      </a-form-model-item>
      <a-form-model-item label="出生日期" prop="birthday" >
      </a-form-model-item>
      <a-form-model-item label="BCS体况评分：1偏瘦 2理想 3偏胖" prop="bcsScore" >
        <a-input v-model="form.bcsScore" placeholder="请输入BCS体况评分：1偏瘦 2理想 3偏胖" />
      </a-form-model-item>
      <a-form-model-item label="是否屋主宠物：1是 0否" prop="isOwner" >
        <a-input v-model="form.isOwner" placeholder="请输入是否屋主宠物：1是 0否" />
      </a-form-model-item>
      <a-form-model-item label="当前体重(kg)" prop="currentWeight" >
        <a-input v-model="form.currentWeight" placeholder="请输入当前体重(kg)" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPet, addPet, updatePet } from '@/api/mibo/pet'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        name: null,

        avatar: null,

        categoryId: null,

        breedId: null,

        gender: null,

        birthday: null,

        bcsScore: null,

        isOwner: null,

        currentWeight: null,

        sort: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '宠物姓名不能为空', trigger: 'blur' }
        ],
        avatar: [
          { required: true, message: '宠物头像不能为空', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '品类ID不能为空', trigger: 'blur' }
        ],
        breedId: [
          { required: true, message: '品种ID不能为空', trigger: 'blur' }
        ],
        gender: [
          { required: true, message: '性别：1公 2母不能为空', trigger: 'blur' }
        ],
        bcsScore: [
          { required: true, message: 'BCS体况评分：1偏瘦 2理想 3偏胖不能为空', trigger: 'blur' }
        ],
        isOwner: [
          { required: true, message: '是否屋主宠物：1是 0否不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        name: null,
        avatar: null,
        categoryId: null,
        breedId: null,
        gender: null,
        birthday: null,
        bcsScore: null,
        isOwner: null,
        currentWeight: null,
        sort: null,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPet({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updatePet(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPet(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
